// ESM-Huelle fuer lib/scripts/components/CMP_CMultiClickDate.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CMultiClickDate(id)
{
    this.construct(id);

    this.name = "CClickNumber";
    this.htmlType = "span";

    this.properties =
    {
        text:
        {
            caption:
            {
                styles:
                {
                    fontSize: "4.5vh",
                    fontFamily: "Verdana, Sans-Serif"
                }
            },
            styles:
            {
                position: "absolute",
                width: "2.5vw",
                height: "7.5vw",
                backgroundColor: ""
            }
        },
        styles:
        {
            left: "10vw",
            top: "6vw"
        }
    }

    this.day = null;
    this.month = null;
    this.year = null;
}

CMultiClickDate.prototype = new CComponent;

CMultiClickDate.prototype.prepare = function()
{
    this.currentLeft = Number(String(this.properties.styles.left).replace("vw",""));

    this.day = this.addDateComponent ("day");
    this.addSeparator ();
    this.month = this.addDateComponent ("month");
    this.addSeparator ();
    this.year = this.addDateComponent ("year");
    
    this.prepared = true;
}

CMultiClickDate.prototype.addDateComponent = function(type)
{
    var dateComponent = this.addChild (CMultiClickNumber);
    dateComponent.properties = combine(dateComponent.properties, this.properties);
    dateComponent.preCommaDigits = 2;
    dateComponent.postCommaDigits = 0;
    dateComponent.properties.styles.left = this.currentLeft + "vw";
    dateComponent.prepare();
    dateComponent.preCDArray[0].prepare();

    switch (type)
    {
        case "day":
            dateComponent.preCDArray[0].numberArray = new Array (0, 1, 2, 3);
//            dateComponent.preCDArray[0].setValue(2);
            break;
        case "month":
            dateComponent.preCDArray[0].numberArray = new Array (0, 1);
            break;
        case "year":
            break;
    }
    this.currentLeft += 7.2;

    return dateComponent;
}

CMultiClickDate.prototype.addSeparator = function()
{
    var text = this.addChild(CTextLabel);
    text.properties.caption.value = ".";
    text.properties = combine(text.properties, this.properties.text);
    text.properties.styles.left = this.currentLeft + "vw";
    text.properties.styles.top = this.properties.styles.top;

    this.currentLeft += 1.6;
}

CMultiClickDate.prototype.getValue = function()
{
    var date = "";

    date += this.day.getValue() + ".";
    date += this.month.getValue() + ".";
    date += this.year.getValue();

    return date;
}

CMultiClickDate.prototype.setValue = function(value)
{
    var valueParts = value.toString().split(".");

    this.day.setValue(valueParts[0]);
    this.month.setValue(valueParts[1]);
	if (valueParts[2].length>2){
		valueParts[2]=valueParts[2].substr(2, 2);
	}
    this.year.setValue(valueParts[2]);
}
export { CMultiClickDate };
